import { callApiToServer } from "../callApi";

export async function addVendor(authtoken, vendorObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      corppass_id: vendorObject.corppass_id,
      categories: vendorObject.categories,
      entity_name: vendorObject.entity_name,
      primary_activity: vendorObject.primary_activity,
      secondary_activity: vendorObject.secondary_activity,
    });

    let endUrl = "v1/auth/vendor";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
